function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { get } from "lodash";
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import ReactPlayer from "react-player";
// import { NEW_EDGE_REG } from "@views/thinking-layout-editor/constants";
import { LoadMore } from "../components/LoadMore";
import styles from "./Video.module.css";
// import utilIndex from "../../../../views/thinking-layout-editor/utils";
import { GetItContext } from "../../base/provider/GetItContext";
import { PageNext } from "./PageNext";
import { PagePrevious } from "./PagePrevious";
import { useSignal } from "@preact/signals-react";
import cls from "classnames";
import { BrainClient } from "imagica-corekit/dist/base/api/BrainClient";
import { Youtube } from "imagica-corekit/dist/base/api/youtubeTyped/Youtube";
import { JsonUtil } from "imagica-corekit/dist/base/cutil/JsonUtil";
import { tryPromise } from "imagica-corekit/dist/base/cutil/LangUtil";

// SharePage用到
var AdaptScreenWidth = /*#__PURE__*/function (AdaptScreenWidth) {
  AdaptScreenWidth[AdaptScreenWidth["Tiny"] = 0] = "Tiny";
  AdaptScreenWidth[AdaptScreenWidth["Middle"] = 1] = "Middle";
  AdaptScreenWidth[AdaptScreenWidth["Huge"] = 2] = "Huge";
  return AdaptScreenWidth;
}(AdaptScreenWidth || {});
export var Video = function Video(props) {
  var _playerWrapperRef$cur3, _currentVideo$value$u, _currentVideo$value, _currentVideo$value$t, _currentVideo$value2, _currentVideo$value$d, _currentVideo$value3;
  var youtube = new Youtube();
  var getIt = useContext(GetItContext);
  var brainClient = getIt(BrainClient);
  var playerWrapperRef = useRef(null);
  var _useState = useState(youtube),
    _useState2 = _slicedToArray(_useState, 2),
    videoInfo = _useState2[0],
    setVideoInfo = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    videoList = _useState4[0],
    setVideoList = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    loading = _useState6[0],
    setLoading = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    keyword = _useState8[0],
    setKeyword = _useState8[1];
  var content = props.content,
    dragging = props.dragging,
    noWheelClassName = props.noWheelClassName;
  var firstPageVideoInfo = useMemo(function () {
    var _JsonUtil$toModelFrom;
    var result = (_JsonUtil$toModelFrom = JsonUtil.toModelFromType(Youtube, content)) !== null && _JsonUtil$toModelFrom !== void 0 ? _JsonUtil$toModelFrom : youtube;
    return result;
  }, [content]);
  var currentVideo = useSignal(get(firstPageVideoInfo.items, [0]));
  var YOUTOBEICON = "https://dopniceu5am9m.cloudfront.net/static/imagica.ai/230704/youtobe_icon.png";
  var videoPlayerHeight = useSignal(0);
  var videoItemImgWidth = useSignal(0);
  var videoItemHeight = useSignal(0);
  var isSupportShowMore = useSignal(false);
  var isShowMore = useSignal(false);
  var isSelectFirstVideo = useSignal(false);
  var currentVideoIndex = useSignal(0);
  var videoListRef = useRef(null);
  var titleRef = useRef(null);
  var descriptionRef = useRef(null);
  var videoListHeight = useSignal(0);
  // 只有huge宽度屏幕时使用，用来设置整个node的高度
  var nodeHeight = useSignal(0);
  // 基于不同屏幕宽度的设计图宽高基准
  var adaptParams = useSignal({
    playerWidth: 240,
    playerHeight: 130,
    horizontalEdgeSpace: 20,
    // 10，左右相加=20
    type: AdaptScreenWidth.Tiny
  });
  var handleClickSelectVideo = function handleClickSelectVideo(video) {
    handleCurrentVideoChange(video);
    currentVideoIndex.value = videoList.indexOf(video);
  };
  var handleCurrentVideoChange = function handleCurrentVideoChange(video) {
    if (currentVideo.value === video) {
      return;
    }
    isShowMore.value = false;
    currentVideo.value = video;
    isSelectFirstVideo.value = video === firstPageVideoInfo.items.first();
  };

  // const handleKeyword = () => {
  //   const nodeId = props.nodeId || props.id;
  //   const nodesArr = getNodes();
  //   const edgesArr = props.getEdges();
  //   let hasOriginNode = edgesArr.find(x => x.target === nodeId);

  //   // v3版本 还需要顺着往前找到sourceNode
  //   if (NEW_EDGE_REG.test(hasOriginNode.source)) {
  //     hasOriginNode = edgesArr.find(x => x.target === hasOriginNode.source);
  //   }

  //   if (isEmpty(hasOriginNode)) {
  //     return;
  //   }

  //   const originNode = hasOriginNode.source;
  //   const originNodeContent = nodesArr.find(x => x.id === originNode);

  //   if (isEmpty(originNodeContent)) return;

  //   const keyword = utilIndex.getTextFromTextAreaValueByType(originNodeContent.data);
  //   // 只处理返回为字符串的问题，其他类型为空
  //   if (typeof keyword === "string") {
  //     setKeyword(keyword);
  //   }
  // };

  var handleClickLoadMore = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var result, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setLoading(true);
            _context.next = 3;
            return tryPromise(brainClient.openAi.getYoutubeV2({
              context: videoInfo === null || videoInfo === void 0 ? void 0 : videoInfo.context,
              continuation: videoInfo === null || videoInfo === void 0 ? void 0 : videoInfo.continuation,
              key: videoInfo === null || videoInfo === void 0 ? void 0 : videoInfo.key
            }));
          case 3:
            result = _context.sent;
            setLoading(false);
            if (result.data) {
              data = result.data.data.data;
              setVideoInfo(data);
              setVideoList(function (list) {
                return [].concat(_toConsumableArray(list), _toConsumableArray(data.items));
              });
            }
            if (result.error) {
              console.log(result.error);
            }
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleClickLoadMore() {
      return _ref.apply(this, arguments);
    };
  }();
  var resetVideoNodeState = useCallback(function () {
    setKeyword(firstPageVideoInfo.query);
    setVideoInfo(firstPageVideoInfo);
    setVideoList(firstPageVideoInfo.items || []);
    currentVideo.value = get(firstPageVideoInfo.items, [0]);
    isSelectFirstVideo.value = true;
  }, [firstPageVideoInfo]);
  useEffect(function () {
    resetVideoNodeState();
  }, [firstPageVideoInfo]);
  useEffect(function () {
    if (playerWrapperRef.current) {
      var iframeNode = playerWrapperRef.current.querySelector("iframe");
      if (iframeNode) {
        iframeNode.style.pointerEvents = dragging === true ? "none" : "auto";
      }
    }
  }, [dragging]);
  useEffect(function () {
    if (!props.isShare) {
      return;
    }
    var windowWidth = window.innerWidth;
    var params = adaptParams.value;
    if (windowWidth < 768) {
      params = {
        playerWidth: 240,
        playerHeight: 130,
        horizontalEdgeSpace: 20,
        // 10，左右相加=20
        type: AdaptScreenWidth.Tiny
      };
    } else if (windowWidth < 1280) {
      params = {
        playerWidth: 380,
        playerHeight: 215,
        horizontalEdgeSpace: 40,
        // 20，左右相加=40
        type: AdaptScreenWidth.Middle
      };
    } else {
      params = {
        playerWidth: 240,
        playerHeight: 135,
        horizontalEdgeSpace: 80,
        // 40，左右相加=80
        type: AdaptScreenWidth.Huge
      };
    }
    if (params.type != adaptParams.value.type) {
      adaptParams.value = params;
    }
  }, [window.innerWidth]);
  useEffect(function () {
    var _playerWrapperRef$cur, _playerWrapperRef$cur2;
    var wrapperWidth = (_playerWrapperRef$cur = (_playerWrapperRef$cur2 = playerWrapperRef.current) === null || _playerWrapperRef$cur2 === void 0 ? void 0 : _playerWrapperRef$cur2.offsetWidth) !== null && _playerWrapperRef$cur !== void 0 ? _playerWrapperRef$cur : 0;
    // 根据不同宽度动态设置好的基准布局参数
    var _adaptParams$value = adaptParams.value,
      playerWidth = _adaptParams$value.playerWidth,
      playerHeight = _adaptParams$value.playerHeight,
      horizontalEdgeSpace = _adaptParams$value.horizontalEdgeSpace,
      type = _adaptParams$value.type;
    if (wrapperWidth > horizontalEdgeSpace) {
      var contentWidth = wrapperWidth - horizontalEdgeSpace;
      // 一列纵向布局
      var actualPlayerWidth = contentWidth;
      if (type == AdaptScreenWidth.Huge) {
        // 两列布局，playerWidth不一样
        actualPlayerWidth = (contentWidth - 20) / 2; // 20: 两列UI的中间间距
      }
      // 当前宽度对于设计基准宽度的缩放比
      var widthResizeRatio = actualPlayerWidth / playerWidth;
      videoPlayerHeight.value = widthResizeRatio * playerHeight;
      // 设计图上
      // itemWidth : playerWidth = 110:playerWidth
      // itemWidth : itemHeight = 110:60
      // 根据playerWidth和itemWidth在设计图上的宽度比算出实际应显示的宽高
      videoItemImgWidth.value = widthResizeRatio * 110;
      videoItemHeight.value = widthResizeRatio * 60;
      switch (adaptParams.value.type) {
        case AdaptScreenWidth.Tiny:
          // 10: 选中框上下延伸各为5
          videoListHeight.value = videoItemHeight.value + 10;
          break;
        case AdaptScreenWidth.Middle:
          // 显示4个item，参数 15：gap, 10: 选中框上下延伸各为5
          videoListHeight.value = videoItemHeight.value * 4 + 15 * 3 + 10;
          break;
        case AdaptScreenWidth.Huge:
          videoListHeight.value = videoItemHeight.value * 3 + 15 * 2;
          // 整个高度要正常显示三个videoItem,设计图上余下的整体高度减去外部上下边距20(20不能算在边距内，因为是外部的nodeWrapper已设置过)，其余边距和控件高度为150
          nodeHeight.value = videoListHeight.value + 150;
          break;
        default:
          break;
      }
    }
  }, [(_playerWrapperRef$cur3 = playerWrapperRef.current) === null || _playerWrapperRef$cur3 === void 0 ? void 0 : _playerWrapperRef$cur3.offsetWidth, adaptParams.value.type]);
  useEffect(function () {
    var _titleRef$current$scr, _titleRef$current, _descriptionRef$curre, _descriptionRef$curre2;
    // lineHeight 都是20,所以大于40就超过两行了
    isSupportShowMore.value = ((_titleRef$current$scr = (_titleRef$current = titleRef.current) === null || _titleRef$current === void 0 ? void 0 : _titleRef$current.scrollHeight) !== null && _titleRef$current$scr !== void 0 ? _titleRef$current$scr : 0) > 40 || ((_descriptionRef$curre = (_descriptionRef$curre2 = descriptionRef.current) === null || _descriptionRef$curre2 === void 0 ? void 0 : _descriptionRef$curre2.scrollHeight) !== null && _descriptionRef$curre !== void 0 ? _descriptionRef$curre : 0) > 40;
  }, [currentVideo.value]);
  var handleClickPrevious = function handleClickPrevious() {
    if (currentVideoIndex.value > 0) {
      currentVideoIndex.value--;
      handleCurrentVideoChange(videoList[currentVideoIndex.value]);
      videoListHandleScroll(true);
    }
  };
  var handleClickNext = function handleClickNext() {
    if (currentVideoIndex.value < videoList.length - 1) {
      currentVideoIndex.value++;
      handleCurrentVideoChange(videoList[currentVideoIndex.value]);
      videoListHandleScroll(false);
    }
  };
  var videoListHandleScroll = function videoListHandleScroll(isPrevious) {
    if (adaptParams.value.type == AdaptScreenWidth.Tiny) {
      var _videoListRef$current, _videoListRef$current2, _videoListRef$current3, _videoListRef$current4, _videoListRef$current5, _videoListRef$current6, _videoListRef$current7;
      // 列表横向布局
      var currentVideoLeft = currentVideoIndex.value * (videoItemImgWidth.value + 10);
      var currentVideoRight = (currentVideoIndex.value + 1) * (videoItemImgWidth.value + 10);
      var clientWidth = (_videoListRef$current = (_videoListRef$current2 = videoListRef.current) === null || _videoListRef$current2 === void 0 ? void 0 : _videoListRef$current2.clientWidth) !== null && _videoListRef$current !== void 0 ? _videoListRef$current : 0;
      var scrollWidth = (_videoListRef$current3 = (_videoListRef$current4 = videoListRef.current) === null || _videoListRef$current4 === void 0 ? void 0 : _videoListRef$current4.scrollWidth) !== null && _videoListRef$current3 !== void 0 ? _videoListRef$current3 : 0;
      var scrollLeft = (_videoListRef$current5 = (_videoListRef$current6 = videoListRef.current) === null || _videoListRef$current6 === void 0 ? void 0 : _videoListRef$current6.scrollLeft) !== null && _videoListRef$current5 !== void 0 ? _videoListRef$current5 : 0;
      var left = -1;
      if (isPrevious) {
        var shouldToLeft = currentVideoLeft - 5; // 5: 左边框
        // 处理点击上一页
        if (shouldToLeft < scrollLeft) {
          left = currentVideoIndex.value == 0 ? 0 : shouldToLeft;
        }
      } else {
        // 处理点击下一页
        var _shouldToLeft = currentVideoRight - clientWidth;
        if (_shouldToLeft > scrollLeft) {
          left = _shouldToLeft;
        }
      }
      if (left < 0 || left > scrollWidth) {
        return;
      }
      (_videoListRef$current7 = videoListRef.current) === null || _videoListRef$current7 === void 0 || _videoListRef$current7.scrollTo({
        left: left,
        behavior: "smooth"
      });
    } else {
      var _videoListRef$current8, _videoListRef$current9, _videoListRef$current10, _videoListRef$current11, _videoListRef$current12, _videoListRef$current13, _videoListRef$current14;
      // 列表纵向布局
      var currentVideoTop = currentVideoIndex.value * (videoItemHeight.value + 15);
      var currentVideoBottom = (currentVideoIndex.value + 1) * (videoItemHeight.value + 15);
      var listHeight = (_videoListRef$current8 = (_videoListRef$current9 = videoListRef.current) === null || _videoListRef$current9 === void 0 ? void 0 : _videoListRef$current9.clientHeight) !== null && _videoListRef$current8 !== void 0 ? _videoListRef$current8 : 0;
      var scrollHeight = (_videoListRef$current10 = (_videoListRef$current11 = videoListRef.current) === null || _videoListRef$current11 === void 0 ? void 0 : _videoListRef$current11.scrollHeight) !== null && _videoListRef$current10 !== void 0 ? _videoListRef$current10 : 0;
      var scrollTop = (_videoListRef$current12 = (_videoListRef$current13 = videoListRef.current) === null || _videoListRef$current13 === void 0 ? void 0 : _videoListRef$current13.scrollTop) !== null && _videoListRef$current12 !== void 0 ? _videoListRef$current12 : 0;
      var top = -1;
      if (isPrevious) {
        var shouldToTop = currentVideoTop - 5; // 5: 上边框
        // 处理点击上一页
        if (shouldToTop < scrollTop) {
          top = currentVideoIndex.value == 0 ? 0 : shouldToTop;
        }
      } else {
        // 处理点击下一页
        var _shouldToTop = currentVideoBottom - listHeight;
        if (_shouldToTop > scrollTop) {
          top = _shouldToTop;
        }
      }
      if (top < 0 || top > scrollHeight) {
        return;
      }
      (_videoListRef$current14 = videoListRef.current) === null || _videoListRef$current14 === void 0 || _videoListRef$current14.scrollTo({
        top: top,
        behavior: "smooth"
      });
    }
  };
  var toggleShowMore = function toggleShowMore() {
    isShowMore.value = !isShowMore.value;
    if (isShowMore.value) {
      props.videoNodeSetAutoHeight();
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(props.isShare && styles.sharePage, " ").concat(styles.scrollContent, " ").concat(props.isTargetNode ? styles["target"] : "", " ").concat(noWheelClassName),
    ref: playerWrapperRef,
    style: {
      height: adaptParams.value.type == AdaptScreenWidth.Huge ? nodeHeight.value : "unset"
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles.keywordContent
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: YOUTOBEICON,
    alt: ""
  })), /*#__PURE__*/React.createElement("p", null, keyword)), /*#__PURE__*/React.createElement(ReactPlayer, {
    url: (_currentVideo$value$u = (_currentVideo$value = currentVideo.value) === null || _currentVideo$value === void 0 ? void 0 : _currentVideo$value.url) !== null && _currentVideo$value$u !== void 0 ? _currentVideo$value$u : "",
    width: "100%",
    height: videoPlayerHeight.value,
    className: styles.videoPlayerResetHgt,
    style: {
      width: "100%",
      height: "100%",
      borderRadius: "15px",
      overflow: "hidden",
      marginBottom: "10px"
    },
    controls: true
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.info,
    style: {
      maxHeight: adaptParams.value.type == AdaptScreenWidth.Huge ? videoListHeight.value - videoPlayerHeight.value + 50 : "unset"
    }
  }, /*#__PURE__*/React.createElement("div", {
    ref: titleRef,
    className: cls(styles.title, isShowMore.value || styles.textShowLess)
  }, (_currentVideo$value$t = (_currentVideo$value2 = currentVideo.value) === null || _currentVideo$value2 === void 0 ? void 0 : _currentVideo$value2.title) !== null && _currentVideo$value$t !== void 0 ? _currentVideo$value$t : ""), /*#__PURE__*/React.createElement("div", {
    ref: descriptionRef,
    className: cls(styles.description, isShowMore.value || styles.textShowLess)
  }, (_currentVideo$value$d = (_currentVideo$value3 = currentVideo.value) === null || _currentVideo$value3 === void 0 ? void 0 : _currentVideo$value3.description) !== null && _currentVideo$value$d !== void 0 ? _currentVideo$value$d : ""), isSupportShowMore.value && /*#__PURE__*/React.createElement("div", {
    className: styles.showMore,
    onClick: function onClick() {
      return toggleShowMore();
    }
  }, "Show ", isShowMore.value ? "less" : "more"))), /*#__PURE__*/React.createElement("div", {
    className: styles.videoListContainer
  }, /*#__PURE__*/React.createElement("div", {
    ref: videoListRef,
    className: "".concat(styles.scrollList, " ").concat(noWheelClassName).concat(styles.videoListResetHgt),
    style: {
      height: videoListHeight.value,
      marginLeft: isSelectFirstVideo.value ? -5 : 0
    }
  }, videoList.map(function (video) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.item,
      onClick: function onClick() {
        return handleClickSelectVideo(video);
      },
      style: {
        width: adaptParams.value.type == AdaptScreenWidth.Tiny ? videoItemImgWidth.value : "100%",
        height: videoItemHeight.value,
        marginLeft: isSelectFirstVideo.value ? 5 : 0,
        marginRight: isSelectFirstVideo.value ? -5 : 0
      },
      key: video.url
    }, /*#__PURE__*/React.createElement("img", {
      src: video.thumbnailUrl,
      alt: "",
      style: {
        width: adaptParams.value.type == AdaptScreenWidth.Tiny ? "100%" : videoItemImgWidth.value
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: styles.itemTimeLabel
    }, video.length), adaptParams.value.type != AdaptScreenWidth.Tiny && /*#__PURE__*/React.createElement("div", {
      className: styles.itemTitle
    }, video.title), currentVideo.value === video && /*#__PURE__*/React.createElement("div", {
      className: styles.currentVideoWrapper
    }));
  }), /*#__PURE__*/React.createElement(LoadMore, {
    noMore: videoInfo.empty || videoInfo.items.length === 0,
    loading: loading,
    onClick: handleClickLoadMore
  })), /*#__PURE__*/React.createElement("div", {
    className: cls(styles.pagination, props.isShare ? styles.noPagination : "")
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return handleClickPrevious();
    }
  }, /*#__PURE__*/React.createElement(PagePrevious, {
    isEnabled: currentVideoIndex.value > 0
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, currentVideoIndex.value + 1), /*#__PURE__*/React.createElement("span", {
    className: styles.of
  }, "of"), /*#__PURE__*/React.createElement("span", null, videoList.length)), /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return handleClickNext();
    }
  }, /*#__PURE__*/React.createElement(PageNext, {
    isEnabled: currentVideoIndex.value < videoList.length - 1
  })))));
};